import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "fl fs18 fw600 ddgrey text-left ml15 mt3" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(`w100 mt20 text-left`)
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = {
  class: "w100 llgreyBg rad10 mt10 mb10",
  style: {"padding":"8px 20px"}
}
const _hoisted_7 = { class: "fl fw600 mt5 mr15" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "fl"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = { class: "mt10" }
const _hoisted_15 = {
  key: 0,
  id: "ctagList"
}
const _hoisted_16 = ["id", "value"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "fs11" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.openForm)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(`w100 mt20 text-left pointer rad8`),
          style: {"border":"1px solid #dfdfdf","padding":"12px 0"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleForm(true)))
        }, [
          _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.$t(`title.add_attendees`)) + " ", 1),
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/icons/user_plus.png`),
            width: "28",
            height: "28",
            class: "fl pointer"
          }, null, 8, _hoisted_2),
          _hoisted_3
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("label", {
            class: "fl fs18 fw600 ddgrey mb5 text-left pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleForm(false)))
          }, _toDisplayString(_ctx.$t(`title.add_attendees`)) + "  ", 1),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.$t(`title.adding_attendees`)), 1),
              (_ctx.Util.isBlank(_ctx.cm.registrable_attendees))
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t(`title.no_attendees`)), 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.cm.registrable_attendees)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cm.registrable_attendees, (att, attindex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "fl fs15 arial mr5 posRe",
                      key: attindex
                    }, [
                      _createElementVNode("div", {
                        class: "posAb",
                        style: {"width":"18px","top":"-5px","right":"-6px"},
                        onClick: ($event: any) => (_ctx.deleteAttendee(att))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                          width: "22",
                          height: "22",
                          class: "pointer"
                        }, null, 8, _hoisted_11)
                      ], 8, _hoisted_10),
                      _createVNode(_component_UserIcon, {
                        width: 42,
                        canEdit: false,
                        member: att,
                        class: "fw600 fs20 mc mt1",
                        showTooltip: true,
                        tooltipName: `${att.name}\n${att.email}`
                      }, null, 8, ["member", "tooltipName"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _hoisted_12
          ]),
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_TextfieldTag, {
              placeholder: _ctx.$t(`form.name`),
              style: {"border-bottom":"solid 1px #c8c8c8"},
              class: "cal_blanks fw600 fl fs12 mr5 w40",
              list: "ctagList",
              id: "add_attends_name",
              onInputValue: _ctx.inputName,
              value: _ctx.newName
            }, null, 8, ["placeholder", "onInputValue", "value"]),
            _createVNode(_component_TextfieldTag, {
              placeholder: _ctx.$t(`form.email`),
              style: {"border-bottom":"solid 1px #c8c8c8"},
              class: "cal_blanks fw600 fl fs12 mr5 w40",
              list: "ctagList",
              id: "add_attends_email",
              onInputValue: _ctx.inputEmail,
              value: _ctx.newEmail
            }, null, 8, ["placeholder", "onInputValue", "value"]),
            (_ctx.Util.isPresent(_ctx.cm.ctList))
              ? (_openBlock(), _createElementBlock("datalist", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cm.ctList, (ctag, ctagindex) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: ctagindex,
                      id: ctag.search_key,
                      value: ctag.name,
                      class: _normalizeClass(ctag.email)
                    }, [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (_ctx.clickCtagOption(ctag))
                      }, [
                        _createTextVNode(_toDisplayString(ctag.name), 1),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(ctag.email), 1)
                      ], 8, _hoisted_17)
                    ], 10, _hoisted_16))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "rad6 mt2 fs14 fw600 mb20 pointer fl skyblueBg centered hoverGreyBg",
              style: {"width":"18%","height":"32px","line-height":"32px"},
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addAttendee && _ctx.addAttendee(...args)))
            }, _toDisplayString(_ctx.$t(`form.add`)), 1),
            _hoisted_19
          ]),
          _hoisted_20
        ]))
  ]))
}